import React from 'react';
import { Bracket } from '../torneos';

// Pestaña Torneos del panel: crear torneos de eliminatoria, colocar a los participantes, ir dando
// los partidos y elegir cual sale en el overlay. La web (/info/torneos) y el overlay se recargan
// solos con cada cambio (apps/torneos.js).

const SIZES = [2, 4, 8, 16, 32, 64];
const hint = { fontSize: 13, color: '#ccc', fontFamily: 'Arial, Helvetica, sans-serif' };

const AdminTorneos = () => {
    const [torneos, setTorneos] = React.useState([]);
    const [selected, setSelected] = React.useState(null);
    const [form, setForm] = React.useState({ name: '', game: '', size: 8, participants: '' });
    const [games, setGames] = React.useState([]);
    const [status, setStatus] = React.useState('');
    // Un cambio cada vez: dos clics seguidos harian que el segundo pisara al primero.
    const busy = React.useRef(false);

    const load = React.useCallback(() => fetch('/api/torneos').then(res => res.json()).then(setTorneos)
        .catch(() => setStatus('No se pudieron leer los torneos.')), []);
    React.useEffect(() => { load(); }, [load]);
    // Catalogo de la pestaña Juegos, el mismo selector que usan las ligas.
    React.useEffect(() => {
        fetch('/api/adminLogin?action=getGamesOption', { method: 'POST' }).then(res => res.json())
            .then(list => setGames(Array.isArray(list) ? list : [])).catch(() => setStatus('No se pudo leer el catálogo de juegos.'));
    }, []);
    const gameSelect = (value, onChange) => (
        <select className='userSearch' value={value} onChange={(e) => onChange(e.target.value)}>
            <option value=''>Sin juego</option>
            {games.map(g => <option key={g.value} value={g.value}>{g.label.replace(/_/g, ' ')}</option>)}
        </select>
    );

    const run = async (action, body) => {
        if (busy.current) return null;
        busy.current = true;
        setStatus('');
        try {
            const res = await fetch('/api/torneos/' + action, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || 'No se pudo completar.');
            await load();
            return data;
        } catch (err) {
            setStatus(err.message || 'Error de red');
            return null;
        } finally {
            busy.current = false;
        }
    };

    const create = async () => {
        const data = await run('create', form);
        if (data) {
            setSelected(data.torneo._id);
            setForm({ ...form, name: '', participants: '' });
        }
    };

    const torneo = torneos.find(t => t._id === selected) || torneos[0];

    return (
        <div className='heroes formOver'>
            <h1>Torneos</h1>
            <h2>Nuevo torneo</h2>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Nombre</label>
                <input className='userSearch' placeholder='Torneo de Smash' value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Juego</label>
                {gameSelect(form.game, (game) => setForm({ ...form, game: game }))}
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Tamaño del cuadro</label>
                <select className='userSearch' value={form.size} onChange={(e) => setForm({ ...form, size: Number(e.target.value) })}>
                    {SIZES.map(n => <option key={n} value={n}>{n} participantes</option>)}
                </select>
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Participantes (opcional)</label>
                <textarea className='userSearch' rows='4' placeholder={'Uno por línea. También se pueden escribir luego en el cuadro.'}
                    value={form.participants} onChange={(e) => setForm({ ...form, participants: e.target.value })} />
            </div>
            <div className='navTops heroes unselectable'>
                <div onClick={create}>Crear torneo</div>
            </div>

            {status ? <p role='alert' style={{ color: '#ff8a8a', fontWeight: 600 }}>{status}</p> : ''}

            {torneo ? <>
                <h2>Cuadro</h2>
                <div className='navTops heroes unselectable'>
                    {torneos.map(t => (
                        <div key={t._id} className={t === torneo ? 'active' : ''} onClick={() => setSelected(t._id)}>
                            {t.name}{t.overlay ? ' (en overlay)' : ''}
                        </div>
                    ))}
                </div>
                <div className='formFieldRow'>
                    <label className='formFieldLabel heroes'>Juego</label>
                    {gameSelect(torneo.game ? torneo.game._id : '', (game) => run('game', { id: torneo._id, game: game }))}
                </div>
                <div className='navTops heroes unselectable'>
                    <div onClick={() => run('shuffle', { id: torneo._id })}>Mezclar</div>
                    <div onClick={() => run('overlay', { id: torneo._id, on: !torneo.overlay })}>
                        {torneo.overlay ? 'Quitar del overlay' : 'Mostrar en overlay'}
                    </div>
                    <div onClick={() => {
                        if (window.confirm('¿Borrar el torneo "' + torneo.name + '"? No tiene vuelta atrás.')) run('delete', { id: torneo._id });
                    }}>Borrar</div>
                </div>
                <p style={hint}>
                    Pulsa un nombre para darle el partido: pasa a la siguiente ronda en verde y su rival queda en rojo.
                    Si te equivocas, la ↶ junto al ganador deshace su victoria, o pulsa al rival para darle el partido a él.
                    En la primera ronda escribe en los huecos libres para colocar a alguien (la × lo quita).
                    Mezclar recoloca a los que aún no han jugado su partido y los junta en partidos completos
                    (los huecos libres quedan al final); lo decidido no se toca.
                    Overlay para OBS: https://forallia.com/?streamGadgets=torneo
                </p>
                <Bracket key={torneo._id} rounds={torneo.rounds}
                    onWinner={(round, index) => run('winner', { id: torneo._id, round: round, index: index })}
                    onUndo={(round, index) => run('undo', { id: torneo._id, round: round, index: index })}
                    onSlot={(index, name) => run('slot', { id: torneo._id, index: index, name: name })} />
            </> : ''}
        </div>
    );
};

export default AdminTorneos;
